// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___K_pm","delete":"styles_delete__13JV9","update":"styles_update__7xfMT","add":"styles_add__2mXiC"};